import React, { useRef, useState } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  VStack,
} from '../../core-ui';

type Props<T> = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  items: Array<T>;
  renderLabel: (item: T) => string;
  submitButtonText: string;
  onSubmit: (item: T) => void;
};

export default function MergeTagModal<T>(props: Props<T>) {
  const {
    title,
    submitButtonText,
    items,
    renderLabel,
    onSubmit,
    isOpen,
    onClose,
  } = props;
  const [selectedItem, setSelectedItem] = useState(items[0]);
  const submitButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      initialFocusRef={submitButtonRef}
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="left">
            <Text>{t('Select field to insert')}</Text>
            <Select
              options={items}
              isSelected={(item) => item === selectedItem}
              getLabel={(item) => renderLabel(item)}
              onChange={(item) => setSelectedItem(item)}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            ref={submitButtonRef}
            onClick={() => {
              if (selectedItem != null) {
                onSubmit(selectedItem);
              }
              onClose();
            }}
          >
            {submitButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
